import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoadingScreen from './LoadingScreen';

export default function ProtectedRoute({ requireAdmin = false, requireNotCazador = false }) {
    const { user, permissions, loading } = useAuth();

    if (loading) {
        return <LoadingScreen />;
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    if (requireAdmin && !permissions?.canViewLogs) {
        return <Navigate to="/general" replace />;
    }

    if (requireNotCazador && !permissions?.canViewUsers) {
        return <Navigate to="/general" replace />;
    }

    return <Outlet />;
}